var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-snackbar",
    {
      attrs: {
        bottom: _vm.bottom,
        top: _vm.top,
        left: _vm.left,
        right: _vm.right,
        color: _vm.color,
        timeout: _vm.timeout
      },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c(
        "v-layout",
        { attrs: { row: "", "align-center": "" } },
        [
          _vm.icon
            ? _c("v-icon", {
                staticClass: "mr-10",
                attrs: { color: _vm.iconColor },
                domProps: { innerHTML: _vm._s(_vm.icon) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.message
            ? _c("span", { domProps: { innerHTML: _vm._s(_vm.message) } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.button
        ? _c("v-btn", {
            attrs: { color: _vm.buttonColor, text: "" },
            domProps: { innerHTML: _vm._s(_vm.button) },
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f11e2580", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f11e2580","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Snackbar.vue
// module id = null
// module chunks = 